import { render, staticRenderFns } from "./props_flow.vue?vue&type=template&id=6ae9e8da&scoped=true"
import script from "./props_flow.vue?vue&type=script&lang=ts"
export * from "./props_flow.vue?vue&type=script&lang=ts"
import style0 from "./props_flow.vue?vue&type=style&index=0&id=6ae9e8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae9e8da",
  null
  
)

export default component.exports